import { EmptyState, EmptyStateActions, Heading, Text } from '@vtex/shoreline'

import styles from './styles.module.css'

/** Empty state com ícone circular, título, descrição e CTA opcional. */
export const PageEmptyState: React.FC<{
  icon: React.ReactNode
  title: string
  description: string
  action?: React.ReactNode
}> = ({ icon, title, description, action }) => (
  <EmptyState className={styles.empty}>
    <span className={styles.emptyIcon} aria-hidden="true">
      {icon}
    </span>
    <Heading level={2}>{title}</Heading>
    <Text variant="body">{description}</Text>
    {!!action && <EmptyStateActions>{action}</EmptyStateActions>}
  </EmptyState>
)
